import { h } from 'vue';

import vhAutocompleteDropdown from './vh-autocomplete-dropdown';

import { props, computed } from '@/components/input/mixin';

export default {

    inheritAttrs: false,

    // We reuse the props and
    // computed of the `vh-input`😀🤘🏻
    mixins: [props, computed],

    data()
    {
        return {
            event: null,
            timeout: 1000,
            isLoading: false,
        };
    },

    props:
    {
        doneTyping:
        {
            type: Function,
        },

        // determines if the modal
        // show or hide
        isOpen:
        {
            type: Boolean,
            default: false,
        },

        // Collections of arrays
        // to be rendered as option
        items:
        {
            type: Array,
            default: null, // format [{id: 1, label: 'title'}]
        },

        onSelect:
        {
            type: Function,
        },
    },

    mounted()
    {
        window.addEventListener('keyup', this.escapeEvent);
        window.addEventListener('click', this.clickOutside);
    },

    unmounted()
    {
        window.removeEventListener('keyup', this.escapeEvent);
        window.removeEventListener('click', this.clickOutside);
    },

    methods:
    {
        isTyping()
        {
            if (process.env.VUE_APP_DEBUG)
            {
                console.log('user is typing..');
            }

            // Clear the existing event
            clearTimeout(this.event);

            // set timeout to prevent
            // immediate emitting the event
            this.event = setTimeout(() =>
            {
                // emit the function that pass
                // from props
                this.doneTyping();
            }, this.timeout);
        },

        clickOutside(event)
        {
            if (!this.$el.contains(event.target))
            {
                this.close();
            }
        },

        close()
        {
            this.$emit('toggleDropdown', false);
        },

        escapeEvent(event)
        {
            if (event.keyCode === 27)
            {
                this.close();
            }
        },
    },

    render()
    {
        return h(
            'div',

            {
                class: [
                    'vh-position-relative',

                    this.wrapperClasses,

                    this.divClass
                ],

                ref: 'autocompleteWrapper',
            },

            [

                h(
                    'div',

                    {
                        class: 'vh-inline'
                    },
                    
                    [
                        h(
                            'div',

                            {
                                class: 'vh-inline vh-margin-small-right'
                            },

                            Boolean(this.label) && h(
                                'label',
            
                                {
                                    class: [
                                        this.labelClasses,
                                    ],
                                },
            
                                this.label
                            ),
                        ),
                        
                        this.$slots.actions && 
                            h(
                                'div',

                                {
                                    class: 'vh-inline',

                                    style:
                                    {
                                        'margin-top': '-2px'
                                    }
                                },

                                this.$slots.actions()
                            )
                    ]

                    
                ),

                h(
                    'input',

                    {
                        class: [
                            'vh-form-filter',
                            
                            this.classes
                        ],

                        ...this.$attrs,

                        value: this.modelValue,

                        onInput: (event) => {
                            this.isTyping();

                            this.$emit('update:modelValue', event.target.value);
                        },

                        ref: 'autocomplete',
                    }
                ),

                Boolean(this.error) && h(
                    'small',

                    {
                        class: 'vh-text-danger',
                    },

                    this.error
                ),

                h(
                    vhAutocompleteDropdown,

                    {
                        isOpen: this.isOpen,

                        items: this.items,

                        onSelect: this.onSelect,

                        toggleDropdown: (bool) => 
                        {
                            this.$emit('toggleDropdown', bool);
                        },
                    }
                ),
            ]
        );
    },
};
